import { useState } from 'react';
import {
  Avatar,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  Typography,
  alpha,
} from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { useAuth } from '../../../context/AuthContext';
import IndustrialCostProductionReportsOperatorView from '../views/IndustrialCostProductionReportsOperatorView';

export default function IndustrialCostFactoryOperatorPage() {
  const { user, signOut } = useAuth();
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);

  const activeUserName =
    user?.user_metadata?.full_name?.trim() ||
    user?.email?.split('@')[0] ||
    'Usuario de fábrica';

  const activeUserSubtitle = user?.email || 'Sesión activa';

  const handleRequestLogout = () => {
    setLogoutDialogOpen(true);
  };

  const handleCancelLogout = () => {
    setLogoutDialogOpen(false);
  };

  const handleConfirmLogout = async () => {
    try {
      setLogoutDialogOpen(false);
      await signOut();
      window.location.href = '/factory/login';
    } catch (error) {
      console.error('Factory operator logout error', error);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: '#020617',
        color: '#f8fafc',
        px: { xs: 1.5, md: 2.5 },
        py: { xs: 1.5, md: 2.5 },
      }}
    >
      <Stack spacing={2}>
        <Box
          sx={{
            borderRadius: 3,
            border: `1px solid ${alpha('#94a3b8', 0.14)}`,
            bgcolor: alpha('#0f172a', 0.92),
            px: { xs: 1.5, md: 2 },
            py: 1.25,
          }}
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            alignItems={{ xs: 'stretch', sm: 'center' }}
            justifyContent="space-between"
            spacing={1.5}
          >
            <Stack direction="row" spacing={1.25} alignItems="center">
              <Avatar
                sx={{
                  width: 40,
                  height: 40,
                  bgcolor: alpha('#38bdf8', 0.12),
                  color: '#38bdf8',
                  border: `1px solid ${alpha('#38bdf8', 0.28)}`,
                }}
              >
                <AccountCircle fontSize="medium" />
              </Avatar>

              <Box sx={{ minWidth: 0 }}>
                <Typography
                  noWrap
                  sx={{
                    color: '#f8fafc',
                    fontWeight: 900,
                    fontSize: '0.96rem',
                    lineHeight: 1.2,
                  }}
                >
                  {activeUserName}
                </Typography>
                <Typography
                  noWrap
                  sx={{
                    color: '#94a3b8',
                    fontWeight: 700,
                    fontSize: '0.8rem',
                    lineHeight: 1.2,
                  }}
                >
                  {activeUserSubtitle}
                </Typography>
              </Box>
            </Stack>

            <Button
              variant="contained"
              color="error"
              onClick={handleRequestLogout}
              sx={{
                alignSelf: { xs: 'stretch', sm: 'center' },
                fontWeight: 800,
                borderRadius: 2.5,
                textTransform: 'none',
                px: 2,
              }}
            >
              Cerrar sesión
            </Button>
          </Stack>
        </Box>

        <IndustrialCostProductionReportsOperatorView />
      </Stack>

      <Dialog open={logoutDialogOpen} onClose={handleCancelLogout}>
        <DialogTitle>Cerrar sesión</DialogTitle>
        <DialogContent>
          <DialogContentText>
            ¿Seguro que quieres cerrar la sesión del puesto operario?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelLogout}>Cancelar</Button>
          <Button color="error" variant="contained" onClick={handleConfirmLogout}>
            Cerrar sesión
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}